import React from 'react';
import { FiImage } from 'react-icons/fi';

const AdvModalCreate = props => {
	const {
		onVisiblePopup,
		onHandleChangeFile,
		imgUrl,
		usId,
		setImgUrl,
		progressBar,
		setProgressBar,
		addAdv,
		onHandleCreateUserForm,
		advInfo
	} = props;

	return (
			<div>
				<div className="modal__created-blur"></div>
				<div className="modal__created-modal">
					<div className="created__modal-header">
						<h2>Новое объявление</h2>
					</div>

					<div className="created__modal-body">
						<form className="body__form">
							<div className="modal__body-content">

								<div className="content">
									<h4>Фотографии</h4>
									<div className="content__body-photo-description">
										Не допускаются к размещению фотографии с водяными знаками, чужих объектов и
										рекламные баннеры. JPG, PNG или GIF. Максимальный размер файла 10 мб
									</div>
								</div>
								<div className="content__body-loader">
									{imgUrl ? imgUrl.map(img =><div className="img__prew"> <img src={img} alt={"Adv_avatar"}/></div>): null}
									<div className="load__field">
										<FiImage />
										<p>Загрузите фотографии<span>*</span></p>
										<input
											type="file"
											multiple
											className="input__file"
											onChange={onHandleChangeFile}
											id="Photos"
										/>
									</div>
								</div>
								<div className="content">
									<h4>Об объекте</h4>
								</div>
								<div className="content">
									<label>Адрес квартиры<span>*</span></label>
									<input
										type="text"
										className="input__text"
										onChange={onHandleCreateUserForm}
										id="address"
									/>
								</div>

									<div className="left_input">
										<label>Цена<span>*</span></label>
										<input
											type="text"
											className="input__text"
											onChange={onHandleCreateUserForm}
											id="price"
										/>
									</div>

									<div className="centr_input">
										<label>Телефон<span>*</span></label>
										<input
											type="text"
											className="input__text"
											onChange={onHandleCreateUserForm}
											id="phone"
										/>
									</div>

									<div className="right_input">
										<label>Количество комнат<span>*</span></label>
										<input
											type="text"
											className="input__text"
											onChange={onHandleCreateUserForm}
											id="rooms"
										/>
									</div>




									<div className="left_input">
										<label>Площадь<span>*</span></label>
										<input
											type="text"
											className="input__text"
											onChange={onHandleCreateUserForm}
											id="square"
										/>
									</div>

									<div className="centr_input">
										<label>Этаж<span>*</span></label>
										<input
											type="text"
											className="input__text"
											onChange={onHandleCreateUserForm}
											id="floor"
										/>
									</div>


								<div className="content">
									<label>Описание<span>*</span></label>
									<textarea
										type="text"
										className="input__textarea"
										onChange={onHandleCreateUserForm}
										id="description"
									/>
								</div>

							</div>
						</form>
					</div>

					<div className="created__modal-bottom">
						<button type="button" className="close__button" onClick={() => {
							onVisiblePopup("modalUsers");
							setImgUrl([]);
							setProgressBar(0);
						}}>Закрыть</button>

						{progressBar === 100 &&
						advInfo.address !== '' &&
						advInfo.price !== '' &&
						advInfo.phone !== '' &&
						advInfo.rooms !== '' &&
						advInfo.square !== '' &&
						advInfo.floor !== '' &&
						advInfo.description
							?
							<button type="button"
									className="success__button"
									onClick={() => {
										const date = new Date();
										const priceHistory = []
										//console.log(imgUrl);
										//alert(`идентификатор юзера ${usId}`);
										addAdv(
											imgUrl,
											advInfo.address,
											advInfo.price,
											priceHistory,
											advInfo.phone,
											advInfo.rooms,
											advInfo.square,
											advInfo.floor,
											advInfo.description,
											date,
											usId)
										onVisiblePopup("modalUsers");
										setProgressBar(0);
										setImgUrl([]);
									}}>Создать
							</button>
							:

							<button type="button"
									className="disabled__button">Создать
							</button>}
					</div>
				</div>
			</div>
	);
};

export default AdvModalCreate;